
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { WhatsAppFloat } from '../../components/feature/WhatsAppFloat';
import { HeroSection } from './components/HeroSection';
import { QuickInfoSection } from './components/QuickInfoSection';
import { ServicesSection } from './components/ServicesSection';
import { AdditionalServicesSection } from './components/AdditionalServicesSection';
import { GallerySection } from './components/GallerySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProcessSection } from './components/ProcessSection';
import { ContactSection } from './components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0D0D0D]">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <AdditionalServicesSection />
        <GallerySection />
        <TestimonialsSection />
        <ProcessSection />
        <ContactSection />
        <QuickInfoSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default HomePage;
